import { IUserWithRoles } from "@defs/user";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@store";

const user = (state: RootState) => state.auth.currentUser;

const currentUserWithRoles = createSelector([user], (user): IUserWithRoles => {
  // const { groups } = user;

  // console.log("user", user);
  // console.log("groups", groups);

  return {
    ...user,
    superadmin: true,
    adminCategories: true,
    adminUsers: true,
    /*
    superadmin: groups.some((group) =>
      group.permissions.some((p) => p.slug === "management:tickets")
    ),
    adminCategories: groups.some((group) =>
      group.permissions.some((p) => p.slug === "management:categories")
    ),
    adminUsers: groups.some((group) =>
      group.permissions.some((p) => p.slug === "management:users")
    ),
    */
  };
});

export default currentUserWithRoles;
